import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation('common');

  const quickLinks = [
    { label: t('navSpreadsheet'), href: '/spreadsheet' },
    { label: t('navCategories'), href: '/categories' },
    { label: t('navReviews'), href: '/reviews' },
    { label: t('navShipping'), href: '/shipping' },
    { label: t('navCoupons'), href: '/coupons' },
  ];

  const resourceLinks = [
    { label: t('navWarehouse'), href: '/warehouse' },
    { label: t('navQC'), href: '/qc' },
    { label: t('navGuides'), href: '/guides' },
    { label: t('navSafety'), href: '/safety' },
    { label: t('navBlog'), href: '/blog' },
  ];

  const legalLinks = [
    { label: t('navAbout'), href: '/about' },
    { label: t('navContact'), href: '/contact' },
    { label: t('navSafety'), href: '/safety' },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="container-main py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md flex items-center justify-center bg-primary-500">
                <i className="ri-table-line text-background-50 text-sm" />
              </div>
              <span className="font-heading font-bold text-lg text-foreground-950">
                {t('siteName')}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t('whatIsDesc')}
            </p>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-global-line" />
              <span>EN / FR / DA / DE</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4 uppercase tracking-wider">
              {t('footerLinks')}
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4 uppercase tracking-wider">
              {t('footerResources')}
            </h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4 uppercase tracking-wider">
              {t('footerLegal')}
            </h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary text-xs py-2 px-4"
              >
                {t('ctaMainWebsite')}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('footerDisclaimer')}
          </p>
          <p className="text-xs text-foreground-500">
            {t('footerRights')} {new Date().getFullYear()} allchinabuyspread.hair
          </p>
        </div>
      </div>
    </footer>
  );
}